<template>
	<div class="rows">
		<ValidationProvider
			ref="provider"
			:vid="`${computedName}-${generatedId}`"
			:name="options.label"
			:rules="rules"
			v-slot="{ errors, classes }"
			slim
		>
			<div :class="[options.wrapperClass, { disabled: isDisabled, 'mb-8px': errors[0] === undefined }]">
				<label class="input-label d-table w-100 text-center" v-if="options.sidebar">{{ options.label }}</label>
				<span
					:class="[
						options.tooltip ? 'input-tooltip' : '',
						options.unit ? 'input-unit' : '',
						'w-100',
						options.className,
						classes,
					]"
				>
					<div class="telInput">
						<input
							:placeholder="options.label"
							type="text"
							:name="computedName"
							:class="options.className"
							:id="generatedId"
							:value="formatValue(getData())"
							@input="setPhoneData"
							inputmode="tel"
							:disabled="isDisabled"
							v-mask="mask"
							data-hj-allow
						/>
					</div>
					<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
				</span>
				<span
					:class="[
						'error_message error_message--broke',
						options.className,
						{ 'mb-8px': type === 'contracting' },
					]"
					v-if="errors[0]"
				>
					{{ errors[0] }}
				</span>
				<span v-if="options.info" class="hint-info font-italic mt-4px">{{ options.info }}</span>
			</div>
		</ValidationProvider>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';

export default {
	mixins: [shared],
	mounted() {
		this.addRules(this.options.isMobile ? { phone: true } : { wired_phone: true });
	},
	data() {
		return {
			mask: '',
		};
	},
	computed: {
		isDisabled() {
			if (_.has(this.options, 'disabled')) {
				return this.$store.state[this.options.disabled];
			}

			return this.disabled;
		},
	},
	methods: {
		setPhoneData(event) {
			this.setData(this.computedValue(event.target.value));
			this.setMask(event.target.value);
		},
		setMask(value) {
			const valueTemp = value.toString();
			if (valueTemp.startsWith('+')) {
				if (valueTemp.charAt(4) === '1') this.mask = '+## # ### ####';
				else this.mask = '+## ## ### ####';
			} else {
				if (valueTemp.charAt(3) === '1') this.mask = '## # ### ####';
				else this.mask = '## ## ### ####';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.telInput {
	display: inline-flex;
	width: 100%;
	.suffix {
		padding: 15px 10px;
		background-color: rgb(244, 245, 244);
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		widows: 48px;
	}
	input {
		width: 100%;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}
}

.hint-info {
	display: block;
	font-size: 12px;
}
</style>
